/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */

import { Injectable } from '@angular/core';
import { IpGroupApiService, NetworkingApiService, StaticRoutesApiService } from '../../../http';
import { forkJoin, Observable } from 'rxjs';

@Injectable()
export class StaticRoutesService {
    constructor(
        private ipGroupApiService: IpGroupApiService,
        private networkingApiService: NetworkingApiService,
        private staticRoutesApiService: StaticRoutesApiService
    ) {
    }

    /**
     * Get the data required for displaying, adding and editing the static routes.
     */
    public getStaticRouteData(): Observable<any> {
        return new Observable((observer) => {
            const apiCalls = {
                groups: this.ipGroupApiService.getGroups(),
                routes: this.staticRoutesApiService.getRoutes(),
                interfaces: this.networkingApiService.getInterfaces()
            };

            forkJoin(apiCalls)
                .subscribe(
                    dataGroup => {
                        observer.next(dataGroup);
                        observer.complete();
                    },
                    error => {
                        observer.error(error);
                        observer.complete();
                    });
        });
    }
}
